import React from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { RoleService } from 'Services';
import ViewText from './ViewText';
import PageHeader from '../PageHeader';
import PageHeaderTitle from '../PageHeaderTitle';
import styles from './RulesHeader.css';

type RulesHeaderLeftProps = {
    title: string;
    isSandbox?: boolean;
    isMerchant?: boolean;
    disableLink?: boolean;
    isViewDeployedVisible?: boolean;
    useAlternateText?: boolean;
    alternateText?: string;
    tenantGroupId?: string;
} & JSX.IntrinsicElements['div'];

const RulesHeaderLeft: React.FC<RulesHeaderLeftProps> = ({
    className,
    title,
    isSandbox,
    isMerchant,
    disableLink,
    isViewDeployedVisible = true,
    useAlternateText,
    alternateText,
    tenantGroupId,
    ...props
}) => {
    const { t } = useTranslation();

    const DefaultContent = () => {
        return (
            <>
                <PageHeaderTitle title={title} className={className} dataTestId='rules-header-title' />
                {isSandbox !== undefined && (
                    <>
                        <div className={clsx(styles.sandBox, className)} data-testid='rules-header-mode'>
                            {isSandbox ? t('sandbox') : t('deployed')}
                        </div>

                        {RoleService.hasDesignAccess && (
                            <ViewText
                                isSandbox={isSandbox}
                                disabled={disableLink}
                                isViewDeployedVisible={isViewDeployedVisible}
                                tenantGroupId={tenantGroupId}
                                isMerchant={isMerchant}
                            />
                        )}
                    </>
                )}
            </>
        );
    };

    const AlternateContent = () => {
        return <PageHeaderTitle title={alternateText || ''} className={className} dataTestId='rules-header-title' />;
    };

    return (
        <PageHeader.Left className={className} {...props}>
            {useAlternateText ? <AlternateContent /> : <DefaultContent />}
        </PageHeader.Left>
    );
};

export default RulesHeaderLeft;
